"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_4_2_1 = void 0;
/**
 * Migrate to 4.2.1
 *
 * The LeitungBeschriftung option `folienlabel` has been removed.
 *
 *  export enum LeitungBeschriftung {
 *    keine = 'Keine',
 *    folienlabel = 'Folienlabel',
 *    schrumpfschlauch = 'Schrumpfschlauch'
 *  }
 *
 *  =>
 *
 *  export enum LeitungBeschriftung {
 *    keine = 'Keine',
 *    folienlabel = 'Folienlabel'
 *  }
 */
const migration_4_2_1 = (json) => {
    if (json.Leitungen) {
        json.Leitungen = json.Leitungen.map((l) => {
            if (l.Beschriftung === 'Schrumpfschlauch') {
                l.Beschriftung = null;
            }
            return l;
        });
    }
    return json;
};
exports.migration_4_2_1 = migration_4_2_1;
//# sourceMappingURL=migration_4_2_1.js.map